import { post } from 'services/axios'
import { CreateNoteOptions, CreateNoteResponse } from './ribbon.types'

export const createNote = async (
  options: CreateNoteOptions,
): Promise<CreateNoteResponse> => {
  const res = await post<CreateNoteResponse>(`/notes`, options)
  return res.data
}
